var exports = {
  "phone": "xf0b3b88a--4dd8b8--phone",
  "hover-text": "xf0b3b88a--4dd8b8--hover-text",
};

module.exports = exports;
